module.exports = __webpack_public_path__ + "static/media/reg-logo.20887a55.png";